import { DownloadOutlined, MoreHorizOutlined } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import { MouseEvent, ReactElement } from 'react';

import { Menu } from '../';

type Props = {
  title: string;
  updatedAt: string;
  menuItems: ReactElement[];
  onDownload: (event: MouseEvent<HTMLButtonElement>) => void;
};

export const DocumentCard = ({ title, updatedAt, menuItems, onDownload }: Props) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        display: 'flex',
        justifyContent: 'space-between',
        p: 2,
      }}
    >
      <Box>
        <Typography variant="subtitle1" fontSize="16px" fontWeight={700}>
          {title}
        </Typography>
        <Typography color="text.secondary" fontSize="14px" fontWeight={400}>
          {updatedAt}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <IconButton size="small" onClick={onDownload}>
          <DownloadOutlined />
        </IconButton>
        <Menu
          equalMenuWidth={false}
          button={
            <IconButton size="small">
              <MoreHorizOutlined />
            </IconButton>
          }
        >
          {menuItems}
        </Menu>
      </Box>
    </Box>
  );
};
